import { IApplicationData } from "../../../model/application-data";
import { IAuthenticationData } from "../../../model/authentication-data";
import { useNavigate } from "react-router-dom";

export type GobalState = {
    applicationData?: IApplicationData | undefined;
    authenticationData: IAuthenticationData | undefined;
};

export enum ACTION_TYPES {
    setApplicationData = 'setApplicationData',
    setAuthenticationData = 'setAuthenticationData'
}

export const GlobalReducer = (state: GobalState, action: any): GobalState => {
    const { type, payload } = action;

    switch (type) {
        case ACTION_TYPES.setAuthenticationData:
            return {
                ...state,
                authenticationData: payload,
            };
        case ACTION_TYPES.setApplicationData:
            return {
                ...state,
                applicationData: payload,
            };
      
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
}